import React from 'react';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="h-full overflow-y-auto bg-gray-50">
        {children}
    </div>
);

export default AdminLayout;
